import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import Avatar from '../../../components/Avatar';
import CommonHeaderRight from './CommonHeaderRight';
import Icon from '../../../components/icon/Icon';

import { Trans, useTranslation } from 'react-i18next';

const ProfilePageHeader = () => {
	return (
		<Header hasLeftMobileMenu={false}>
			<HeaderLeft>
				<div style={{'textAlign': 'center'}}> 
					Admin portal for Bino Solutions
				</div>
			</HeaderLeft>
			
			<CommonHeaderRight />
		</Header>
	);
};

export default ProfilePageHeader;
